import React from 'react'

export const ArrowDownIcon = ({className}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="12"
      viewBox="0 0 21 12"
      fill="none"
    >
      <path
        d="M10.0774 7.35914L3.27692 0.558626C2.91699 0.200829 2.4301 -1.06223e-07 1.92258 -8.40387e-08C1.41507 -6.18546e-08 0.928175 0.200829 0.568243 0.558626C0.388186 0.737213 0.245271 0.949682 0.147742 1.18378C0.0502128 1.41788 5.02091e-07 1.66897 5.13176e-07 1.92257C5.24261e-07 2.17617 0.0502129 2.42726 0.147742 2.66136C0.245271 2.89546 0.388186 3.10793 0.568243 3.28651L8.71349 11.4318C8.89207 11.6118 9.10454 11.7547 9.33864 11.8523C9.57274 11.9498 9.82383 12 10.0774 12C10.331 12 10.5821 11.9498 10.8162 11.8523C11.0503 11.7547 11.2628 11.6118 11.4414 11.4318L19.6827 3.28651C19.8607 3.10701 20.0016 2.89413 20.0972 2.66007C20.1928 2.42602 20.2412 2.17539 20.2398 1.92257C20.2412 1.66975 20.1928 1.41912 20.0972 1.18507C20.0016 0.951012 19.8607 0.738129 19.6827 0.558625C19.3227 0.200829 18.8358 -8.23341e-07 18.3283 -8.01157e-07C17.8208 -7.78973e-07 17.3339 0.200829 16.974 0.558625L10.0774 7.35914Z"
        fill="#7E92A2"
      />
    </svg>
  )
}
